import List from 'src/storage/list';
import { validateObj } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

class DoctorInvitationsModel extends List {
  id = 'DoctorInvitationsModel';
  defaultState = () => ({
    current: 'recent',
    total: 0,
    pageIndex: 0,
    ...this.defaultInviteInput(),
    updating: {}
  });
  defaultInviteInput = () => ({
    tab: 'search',
    doctor: null,
    email: '',
    fullname: '',
    phoneNumber: '',
    hospitalIds: [],
    bulkList: Array.from({ length: 10 }, () => ({}))
  });

  refreshOnInit = true;
  refreshOnSubscribe = false;
  sortBy = {};

  apiConfig = {
    refresh: {
      url: 'invitation/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'invitation/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'invitation/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    invite: {
      url: 'invitation/send/doctor',
      validation: {
        email: 'email',
        fullname: 'fullName',
        phoneNumber: 'phone'
      },
      cancellable: true
    },
    update: {
      url: 'invitation/update',
      validation: {
        hospitalIds: 'hospitalIds'
      },
      cancellable: true
    },
    invite_detail: {
      url: 'invitation/detail',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },
    remove: {
      url: 'invitation/remove',
      validation: {},
      cancellable: true
    },
    bulk: {
      url: 'invitation/bulk/doctor',
      validation: {},
      cancellable: true
    },
    resend: {
      url: 'invitation/resend',
      validation: {},
      cancellable: true
    }
  };

  _events = {
    'ws:invite_doctor': 'onInviteDoctor',
    location: 'initLocation',
    profile: 'handleChangeProfileAndSwitchAccount'
  };
  onInviteDoctor = (data) => {
    if (data.removedDate) this.removeItem(data.id);
    else {
      this._mergeItems([data], null, true);
      this.trigger();
    }
  };

  _matchMergeItem = (n, o) => ({ ...o, ...n });

  initLocation = (data) => {
    this.cacheState = { tempCountryAddress: data.country };
    this.setState({ tempCountryAddress: data.country });
  };

  listParams() {
    const user = this.getUser();
    const clinicId = user?.isClinic ? user.id : user.managerToClinic;
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      role: 'doctor_' + clinicId
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    if (this.state.hospitalId) {
      req.hospitalIds = [this.state.hospitalId];
    }
    return req;
  }
  sendInvite = (id, cb) => {
    let req = {
      id,
      email: this.input('email') || '',
      fullname: this.input('fullname'),
      phoneNumber: this.input('phoneNumber') || '',
      hospitalIds: this.input('hospitalIds')
    };

    if (req.phoneNumber && req.phoneNumber[0] === '+' && req.phoneNumber.length < 4) {
      req.phoneNumber = '';
    }

    if (this.state.tab === 'search') {
      req = {
        id: this.state.doctor.id,
        email: this.state.doctor.email,
        fullname: this.state.doctor.fullNameLower,
        phoneNumber: this.state.doctor.phoneNumber,
        hospitalIds: this.state.hospitalIds
      };
    } else {
      let invalid = validateObj(req, this.apiConfig.invite.validation);

      if (!req.email && !req.phoneNumber) {
        invalid.emailOrPhone = LANG_CONST.validation.email_or_phone;
        invalid.length++;
      }

      if (invalid.length) {
        return this.setInvalidApi('invite', invalid);
      }
    }
    this.api('invite', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.resetInviteInput();
        this.onInviteDoctor({ ...data.invitation });
      }
    });
  };
  updateInvite = (id, cb) => {
    let req = {
      id,
      hospitalIds: this.input('hospitalIds')
    };
    this.api('update', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.updateItem({ id, hospitals: this.state.hospitals });
      }
    });
  };
  getInvite = (id, cb) => {
    let req = {
      id
    };
    this.api('invite_detail', req, (err, data, success) => {
      if (success) {
        this.setState({
          fullname: data.fullname || '',
          phoneNumber: data.phoneNumber || '',
          email: data.email || '',
          hospitalIds: data.hospitalIds
        });
      }
      cb(err, data, success);
    });
  };
  remove = (item, cb) => {
    let req = {
      id: item.id
    };
    this.api('remove', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (!err) {
        this.onInviteDoctor({ id: item.id, removedDate: Date.now() });
      }
    });
  };

  resetInviteInput = () => {
    this.setState({
      ...this.defaultInviteInput()
    });
  };

  sendBulk = (cb) => {
    const id = 'bulk';
    this.api(id, { users: this.state.bulkList }, cb);
  };

  sendImport = (req, cb) => {
    const id = 'invitation/bulk/doctor';
    this.upload(id, req, () => null, cb);
  };
  resend = (id, cb) => {
    let req = {
      id
    };
    this.api('resend', req, (err, data, success) => {
      !!data?.invitation && this.onInviteDoctor(data.invitation);
      cb && cb(err, data, success);
    });
  };
}

const model = new DoctorInvitationsModel();
export default model;
